import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import { getRoles, resetRoles } from "../../Redux/RolesSlice/RolesSlice";
import { toast } from "react-toastify";
import {
    CreateNewUser,
    CreateUserDocuments,
    getAllUsersWihtoutPage,
    getUserByBusiness,
    reset,
} from "../../Redux/UserSlice/UserSlice";
import { getAllBusiness, resetBusiness } from "../../Redux/BusSlice/BusSlice";

const validationSchema = yup.object({
    name: yup.string("Enter your Name").required(" Name is required "),
    email: yup
        .string("Enter your email")
        .email("Enter a valid email")
        .required("Email is required"),
    password: yup
        .string("Enter your password")
        .min(8, "Password should be of minimum 8 characters length")
        .required("Password is required"),
    password_confirmation: yup
        .string("Enter your Confirm Password")
        .min(8, "Password should be of minimum 8 characters length")
        .required("Confirm Password is required"),
    business_id: yup
        .string("Enter your business")
        .required(" Business is required "),
    // parent: yup.string("Enter your Parent").required(" Parent is required "),
    phone: yup.string("Enter your Phone").required(" Phone is required "),
    ppw: yup.string("Enter your PPW").required(" PPW is required "),
});

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

const CreateUser = () => {
    const dispatch = useDispatch();
    const [roles, setroles] = useState([]);
    const { user, usersByBusiness, isLodaing, isError, isSuccess, massage } =
        useSelector((state) => state.users);
    const allRoles = useSelector((state) => state.roles.roles);
    const { business } = useSelector((state) => state.business);
    const user_id = user?.data?.id || false;
    /////////////////////
    const ALL_USER = usersByBusiness?.data ? usersByBusiness?.data : [];
    const ALL_ROLES = allRoles?.data ? allRoles?.data : [];
    const ALL_BUSINESS = business ? business?.data?.data : [];
    // GET THE USERS
    useEffect(() => {
        const getAll = async () => {
            await dispatch(getRoles());
            await dispatch(resetRoles());
            await dispatch(getAllBusiness());
            await dispatch(resetBusiness());
        };
        getAll();
    }, []);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setroles(typeof value === "string" ? value.split(",") : value);
    };

    const GetAllParants = async (business_id) => {
        await dispatch(getUserByBusiness(business_id));
        await dispatch(reset());
    };

    const handleChangeBusiness = (e) => {
        formik.values.business_id = e.target.value;
        GetAllParants(e.target.value);
    };

    const [ein, setEin] = useState("");
    const [w9, setW9] = useState("");
    const [certificates, setCertificates] = useState("");
    const [other_path, setOtherPath] = useState("");
    const [other_name, setOtherName] = useState("");

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            password: "",
            password_confirmation: "",
            business_id: "",
            parent: "",
            phone: "",
            ppw: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            if (
                formik.values.password === formik.values.password_confirmation
            ) {
                await dispatch(CreateNewUser({ ...values, roles }));
                await dispatch(reset());
            } else {
                toast.error("the password not confirmed ");
            }
        },
    });

    useEffect(() => {
        if (user_id) {
            const formData = new FormData();
            formData.append("user_id", user_id);
            formData.append("ein", ein);
            formData.append("w9", w9);
            formData.append("certificates", certificates);
            formData.append("other_path", other_path);
            formData.append("other_name", other_name);

            dispatch(CreateUserDocuments(formData));

            setEin("");
            setW9("");
            setCertificates("");
            setOtherPath("");
            setOtherName("");
        }
    }, [dispatch, user_id]);

    useEffect(() => {
        if (
            formik.values.name &&
            formik.values.email &&
            formik.values.password &&
            formik.values.password_confirmation &&
            formik.values.business_id &&
            formik.values.parent &&
            formik.values.ppw
        ) {
            if (isSuccess) {
                toast.success("The User had been Created ");
            }
        }
        if (isError) {
            toast.error(massage);
        }
        dispatch(reset());
    }, [formik.values, isSuccess, isError, massage]);

    // Handle Change User Documents
    const handelChangeEIN = (e) => {
        console.log(e.currentTarget.files[0]);
        setEin(e.currentTarget.files[0]);
    };
    const handelChangeW9 = (e) => {
        setW9(e.currentTarget.files[0]);
    };
    const handelChangeCertificates = (e) => {
        setCertificates(e.currentTarget.files[0]);
    };
    const handelChangeOtherPath = (e) => {
        setOtherPath(e.currentTarget.files[0]);
    };

    return (
        <>
            <FormHeading>Add a New User </FormHeading>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="name"
                            name="name"
                            label="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.name &&
                                Boolean(formik.errors.name)
                            }
                            helperText={
                                formik.touched.name && formik.errors.name
                            }
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="input-with-icon-textfield"
                            name="email"
                            label="Email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.email &&
                                Boolean(formik.errors.email)
                            }
                            helperText={
                                formik.touched.email && formik.errors.email
                            }
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="password"
                            name="password"
                            label="password"
                            type="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.password &&
                                Boolean(formik.errors.password)
                            }
                            helperText={
                                formik.touched.password &&
                                formik.errors.password
                            }
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="password_confirmation"
                            name="password_confirmation"
                            label="password confirmation"
                            type="password"
                            value={formik.values.password_confirmation}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.password_confirmation &&
                                Boolean(formik.errors.password_confirmation)
                            }
                            helperText={
                                formik.touched.password_confirmation &&
                                formik.errors.password_confirmation
                            }
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <FormControl fullWidth required={true}>
                            <InputLabel id="demo-multiple-name-label">
                                Role
                            </InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                multiple
                                value={roles}
                                onChange={handleChange}
                                required={true}
                                input={<OutlinedInput label="Name" />}
                                // MenuProps={MenuProps}
                            >
                                {ALL_ROLES?.map((key) => (
                                    <MenuItem key={key.id} value={key.id}>
                                        {key.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <FormControl fullWidth required={true}>
                            <InputLabel id="demo-simple-select-label">
                                Business
                            </InputLabel>
                            <Select
                                required={true}
                                id="business_id"
                                name="business_id"
                                label="Business"
                                value={formik.values.business_id}
                                // onSelect={() => GetAllParants()}
                                onChange={handleChangeBusiness}
                            >
                                {ALL_BUSINESS?.map((key) => (
                                    <MenuItem key={key.id} value={key.id}>
                                        {key.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="phone"
                            name="phone"
                            label="Phone"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.phone &&
                                Boolean(formik.errors.phone)
                            }
                            helperText={
                                formik.touched.phone && formik.errors.phone
                            }
                        />
                    </Grid>
                    {ALL_USER && ALL_USER.length !== 0 && (
                        <Grid item mb={2} xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Parent
                                </InputLabel>
                                <Select
                                    id="parent"
                                    name="parent"
                                    label="parent "
                                    value={formik.values.parent}
                                    onChange={formik.handleChange}
                                >
                                    {ALL_USER?.map((key) => (
                                        <MenuItem key={key.id} value={key.id}>
                                            {key.name} : {key.email}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="ppw"
                            name="ppw"
                            label="ppw"
                            type="number"
                            value={formik.values.ppw}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.ppw && Boolean(formik.errors.ppw)
                            }
                            helperText={formik.touched.ppw && formik.errors.ppw}
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="ein"
                            name="ein"
                            label="EIN"
                            type="file"
                            onChange={(e) => handelChangeEIN(e)}
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="w9"
                            name="w9"
                            label="W9"
                            type="file"
                            onChange={(e) => handelChangeW9(e)}
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="certificates"
                            name="certificates"
                            label="Certificates"
                            type="file"
                            onChange={(e) => handelChangeCertificates(e)}
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="other_path"
                            name="other_path"
                            label="Other File"
                            type="file"
                            onChange={(e) => handelChangeOtherPath(e)}
                        />
                    </Grid>
                    {/* <Grid item mb={2} xs={12} md={6}>
                <InputLabel>Active ?</InputLabel>
                <span>No</span>
                <Switch
                id="is_active"
                name="is_active"
                checked={formik.values.is_active}
                onChange={formik.handleChange}
                inputProps={{ "aria-label": "controlled" }}
                />
                <span>Yes</span>
            </Grid> */}
                </Grid>

                <PrimaryButton fullWidth type="submit">
                    {isLodaing ? "loading..." : "Create"}
                </PrimaryButton>
            </form>
        </>
    );
};

export default CreateUser;
